const Unauthorized = () => {
  return <h4>Unauthorized</h4>;
};

export default Unauthorized;
